import { HardwareFeature, ColorTheme } from "./types";

export const trackerColorTheme: ColorTheme = {
    orange: {
        gradient: "from-orange-400 to-orange-600",
        rgb: "249, 115, 22",
    },
    red: {
        gradient: "from-red-400 to-red-600",
        rgb: "239, 68, 68",
    },
    amber: {
        gradient: "from-amber-400 to-amber-600",
        rgb: "245, 158, 11",
    },
    yellow: {
        gradient: "from-yellow-400 to-yellow-600",
        rgb: "234, 179, 8",
    },
    deepOrange: {
        gradient: "from-orange-500 to-red-500",
        rgb: "249, 115, 22",
    },
    crimson: {
        gradient: "from-red-500 to-rose-600",
        rgb: "220, 38, 127",
    },
    coral: {
        gradient: "from-orange-300 to-pink-400",
        rgb: "251, 146, 60",
    },
    sunset: {
        gradient: "from-yellow-400 to-orange-500",
        rgb: "251, 191, 36",
    },
};

export const TrackerHardwareFeatures: HardwareFeature[] = [
    {
        image: "../media/Hardware feature/tracker/Frame 66.webp",
        className: "col-span-12 md:col-span-4 row-span-1 md:row-span-3",
        color: "orange",
    },
    {
        image: "../media/Hardware feature/tracker/Frame 63.webp",
        className: "col-span-12 md:col-span-4 row-span-1 md:row-span-2 md:col-start-1 md:row-start-4",
        color: "red",
    },
    {
        image: "../media/Hardware feature/tracker/Frame 53.webp",
        className: "col-span-12 md:col-span-4 row-span-1 md:row-span-5 md:col-start-5 md:row-start-1",
        color: "amber",
    },
    {
        image: "../media/Hardware feature/tracker/Frame 64.webp",
        className: "col-span-12 md:col-span-2 row-span-1 md:row-span-2 md:col-start-9 md:row-start-1",
        color: "deepOrange",
    },
    {
        image: "../media/Hardware feature/tracker/Frame 59.webp",
        className: "col-span-12 md:col-span-2 row-span-1 md:row-span-2 md:col-start-11 md:row-start-1",
        color: "crimson",
    },
    {
        image: "../media/Hardware feature/tracker/Frame 67.webp",
        className: "col-span-12 md:col-span-4 row-span-1 md:row-span-3 md:col-start-9 md:row-start-3",
        color: "sunset",
    },
];